import React, { Component } from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"
import store from "store"
import { CircularProgress, withWidth } from "@material-ui/core"

import AuthenticateUser from "../Decorators/Authenticator"

import Shopify from "src/helpers/Shopify"

import Header from "../Shared/Header"
import Footer from "../Shared/Footer"
import "./layout.css"
import "./layoutExtended.css"

const shopify = new Shopify()

@withWidth()
@AuthenticateUser()
export default class Layout extends Component {
  state = {
    joinOpen: false,
    regError: null
  }

  componentDidMount = async () => {
    try {
      await shopify.build()
      await this.checkCart()
    } catch (ex) {
      console.error(ex)
    }
  }

  getDisplayClass = () => {
    const { width } = this.props

    switch (width) {
      case "xs":
      case "sm":
        return "mobile"
      default:
        return "desktop"
    }
  }

  getBroswerClass = () => {
    const winNav = window.navigator
    const userAgent = winNav && winNav.userAgent

    if (userAgent) {
      if (userAgent.includes("MSIE ") || userAgent.includes("Trident/")) {
        return "ie"
      }
    }

    return "compat"
  }

  checkCart = async () => {
    try {
      const checkout = await shopify.getCheckout()

      let itemsInCart = 0

      if (checkout) {
        checkout.lineItems.forEach(item => {
          itemsInCart += +item.quantity
        })
      }

      this.setState({
        cart: checkout,
        itemsInCart,
      })
    } catch (err) {
      console.error(err)
    }
  }

  render() {
    const { children, typeOfNav, userInfo, headerType, footerType } = this.props

    const isProd = process.env.GATSBY_ENVIRONMENT === "production"

    const userInfoLoading = !Object.keys(userInfo).length

    const displayClass = this.getDisplayClass()

    const browserClass = this.getBroswerClass()

    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: "description", content: "Sample" },
                { name: "keywords", content: "sample, something" },
              ]}
            >
              <html lang="en" />
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css?family=Droid+Serif:400,400i,700,700i|Montserrat:300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i"
              />
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,600"
              />
              <script
                async
                src="https://us-library.klarnaservices.com/merchant.js?uci=390bbe32-7b3f-4495-87a1-592983fb37b9&country=US"
              />
              <script>{
                `(function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");
                vgo('setAccount', '90162374');
                vgo('setTrackByDefault', true);
                vgo('process');`
              }</script>
              <script src="https://code.jquery.com/jquery-1.11.0.min.js" />
              <script>{
                `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
                  {'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-KLQNG7Q');`
              }
              </script>
            </Helmet>
            <noscript>
              <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KLQNG7Q"
                height="0" width="0" style="display:none;visibility:hidden">
              </iframe>
            </noscript>
             {!userInfoLoading ? (
              <div>
                {typeOfNav !== "none" && (
                  <Header
                    {...this.state}
                    headerUserInfo={userInfo}
                    siteTitle={data.site.siteMetadata.title}
                    typeOfHeader={headerType}
                    displayClass={displayClass}
                  />
                )}
                <div id="site-container">
                  {React.Children.map(children, c =>
                    React.cloneElement(c, {
                      userInfo,
                      displayClass,
                      browserClass,
                      updateCart: this.checkCart,
                    })
                  )}
                </div>
                {typeOfNav !== "none" && (
                  <Footer footerUserInfo={userInfo} typeOfFooter={footerType} />
                )}
              </div>
            ) : (
              <div className="home-loading-wheel">
                <CircularProgress />
              </div>
            )}
          </>
        )}
      />
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
